/****************
 * WHICH SESSIONS COUNT AS LIVE MONEY ON THE DASHBOARD. 2026-09-28.
 *
 * Live means real money on a key we still hold -- the backend's
 * `places_real_orders` (store.PlacesRealOrders), the same rule the admin
 * money card and the equity figures use.
 *
 * "Not paper" was the test, and a broker session detached from a deleted key
 * is not paper -- its badge stays Live -- so its result went into the live Net
 * PnL: Guillaume's 102.47 against the 73.73 his key actually made, the
 * difference being keyless session 222's +28.73.
 *
 * An older backend without the field keeps the old test, so a deploy order
 * cannot empty the live scope.
 ****************/

type SessionLike = {
  session_type?: string;
  delivery_mode?: string;
  is_paper?: boolean;
  places_real_orders?: boolean;
};

export function isSignalSession(s: SessionLike): boolean {
  return s.session_type === 'TELEGRAM' || s.delivery_mode === 'telegram';
}

export function isPaperSession(s: SessionLike): boolean {
  return !isSignalSession(s) && (s.session_type === 'PAPER' || s.is_paper === true);
}

export function isLiveMoneySession(s: SessionLike): boolean {
  if (typeof s.places_real_orders === 'boolean') return s.places_real_orders;
  return !isPaperSession(s) && !isSignalSession(s);
}
